var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.6487V18.0973C4 18.3228 4.1772 18.5 4.40272 18.5H6.85127C6.95598 18.5 7.06069 18.4597 7.13318 18.3792L15.9286 9.59179L12.9082 6.57138L4.12082 15.3588C4.04027 15.4393 4 15.536 4 15.6487ZM18.2644 7.25601C18.5785 6.94188 18.5785 6.43445 18.2644 6.12033L16.3797 4.23559C16.0655 3.92147 15.5581 3.92147 15.244 4.23559L13.77 5.70955L16.7904 8.72997L18.2644 7.25601Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.809e1820112dc5094c904396a07ae654.svg";
export { ForwardRef as ReactComponent };